export const DRUCKPFAHL = "druckpfahl";
export const ZUGPFAHL = "zugpfahl";
export const COMPRESSION_PILE = "compression pile";
export const TENSION_PILE = "tension pile";
export const MAX_BEMESSUNGSLAST = 2209;
export const ALPHA_EQUAL_A_ZERO = 0.13;

// Aufweitung nach DIN SPEC 18539, amin, in cm
export const AUFWEITUNG_NACH_DIN_SPEC_18539 = 20;

// AASHTO
export const MEDIUM_AND_CORASE_GRAVEL = 3;
export const SAND_AND_SANDY_GRAVEL = 2;
export const FOR_INS_WITH_EXT_JETTING = 1;
export const CLAY_OR_ROCK = 0;

// LVText
export const TEST_SEQUENCE_TYPE_SPECIFICATION_BY_GEOTECHNICAL_EXPERT =
  "geotechnischer Sachverständiger";
export const TEST_SEQUENCE_TYPE_DIN_EN_1997_1_DIN_1054_EA_PFAEHLE =
  "DIN EN 1997-1 DIN 1054 EA Pfähle";
export const POLEHEAD_SOURCE_SMARTTITAN = "SmartTitan";
export const POLEHEAD_SOURCE_DETAIL_DRAWINGS = "Detailzeichnungen";
